import { render, staticRenderFns } from "./AccountRequestControls.vue?vue&type=template&id=d70fa4fc&scoped=true&"
import script from "./AccountRequestControls.vue?vue&type=script&lang=js&"
export * from "./AccountRequestControls.vue?vue&type=script&lang=js&"
import style0 from "./AccountRequestControls.vue?vue&type=style&index=0&id=d70fa4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70fa4fc",
  null
  
)

export default component.exports